import eIcon from './excel.svg'
import wIcon from './word.svg'

export const ExcelIcon = eIcon
export const WordIcon = wIcon
